import React from 'react';
import { NavLink as RouterLink, matchPath, useLocation, useHistory } from 'react-router-dom';
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, List, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import { Menu } from 'react-pro-sidebar';
import { _can } from '../../utils';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { Badge } from '@material-ui/core';

const ListItemStyle = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 40,
  position: 'relative',
  textTransform: 'capitalize',
  color: '#D0D5DD!important',
  borderRadius: '6px',
  fontStyle: 'normal',
  fontWeight: '500!important',
  paddingLeft: '8px',
  fontSize: '16px',
  lineHeight: '24px',
  marginBottom: '4px',
  letterSpacing: '0',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '31px',
  marginRight: '9px',
});

function NavItem({ item, active, pathname, user, open, setMenuId }) {
  const theme = useTheme();
  const history = useHistory();
  const { title, path, icon: Icon } = item;

  const isActiveRoot = active(path) || pathname.indexOf(item.path) > -1;

  const activeRootStyle = {
    color: 'primary.main',
    fontWeight: 'fontWeightMedium',
    bgcolor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
  };

  if (item?.hasNestedMenu || item?.isMainMenu) {
    return (
      <>
        <ListItemStyle
          key={title}
          disabled={!user}
          component="div"
          onClick={() => {
            setMenuId(item.menuId);
            history.push(item.path);
          }}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          <ListItemIconStyle>
            <Icon />
          </ListItemIconStyle>
          {!open && !item?.beta && <ListItemText disableTypography primary={title} />}
          {!open && item?.beta && (
            <Badge badgeContent="Beta" color="primary" variant="standard" style={{ alignItems: 'center' }}>
              {item.title}
            </Badge>
          )}
          {item?.hasNestedMenu && <ChevronRightOutlinedIcon />}
        </ListItemStyle>
        {item?.isMainMenu && (
          <div
            style={{
              background: '#475467',
              height: '1px',
              width: '100%',
              margin: '4px 0',
            }}
          />
        )}
      </>
    );
  } else {
    const li = (
      <>
        <ListItemIconStyle>
          <Icon />
        </ListItemIconStyle>
        {!open && <ListItemText disableTypography primary={title} />}
      </>
    );
    return (
      <>
        {item?.heading && (
          <div
            style={{
              textTransform: 'uppercase',
              margin: '12px 0 12px 12px',
              fontSize: '12px',
              fontWeight: 500,
              color: 'rgba(242, 244, 247, 0.9)',
            }}
          >
            {item.heading}
          </div>
        )}
        <ListItemStyle
          key={title}
          disabled={!user}
          component={RouterLink}
          to={path}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          {item?.new && (
            <Badge badgeContent="New" color="primary" variant="standard" style={{ alignItems: 'center' }}>
              {li}
            </Badge>
          )}
          {!item?.new && li}
        </ListItemStyle>
      </>
    );
  }
}

export default function NavSection({ navConfig, user, org, open, setMenuId, ...other }) {
  const { pathname } = useLocation();
  const match = (path) => (path ? !!matchPath(path, pathname) : false);
  const menus =
    navConfig?.filter((i) => (!i.permission || _can(i.permission)) && (!i.orgType || i.orgType === org.type)) ?? [];

  return (
    <Box {...other}>
      <Menu>
        <List disablePadding style={{ padding: '10px 16px 0px' }}>
          {menus.map((item) => (
            <NavItem
              key={item.title}
              item={item}
              pathname={pathname}
              active={match}
              user={user}
              open={open}
              setMenuId={setMenuId}
            />
          ))}
        </List>
      </Menu>
    </Box>
  );
}
